import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  loading: false,
  error: "",
  sessionsList: null,
  sessionDetail: null,
  activeUsers: null,
  detailLoading: false,
  moreLoading: false,
});

export default function journeyReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.JOURNEY_SESSIONS_LIST.PENDING:
      return state.set("loading", true);
    case ACTIONS.JOURNEY_SESSIONS_LIST.SUCCESS:
      return state.set("loading", false).set("error", "").set("sessionsList", action.data);
    case ACTIONS.JOURNEY_SESSIONS_LIST.ERROR:
      return state.set("loading", false).set("error", action.error);

    case ACTIONS.JOURNEY_SESSION_DETAIL.PENDING:
      return action.payload?.append
        ? state.set("moreLoading", true)
        : state.set("detailLoading", true);
    case ACTIONS.JOURNEY_SESSION_DETAIL.SUCCESS: {
      const data = action.data;
      const base = state.set("detailLoading", false).set("moreLoading", false).set("error", "");
      if (data.append && state.get("sessionDetail")) {
        const existing = state.get("sessionDetail");
        const merged = {
          ...data,
          timeline: [...(existing.timeline || []), ...(data.timeline || [])],
        };
        return base.set("sessionDetail", merged);
      }
      return base.set("sessionDetail", data);
    }
    case ACTIONS.JOURNEY_SESSION_DETAIL.ERROR:
      return state.set("detailLoading", false).set("moreLoading", false).set("error", action.error);

    case ACTIONS.JOURNEY_ACTIVE_USERS.PENDING:
      return state.set("loading", true);
    case ACTIONS.JOURNEY_ACTIVE_USERS.SUCCESS:
      return state.set("loading", false).set("activeUsers", action.data);
    case ACTIONS.JOURNEY_ACTIVE_USERS.ERROR:
      return state.set("loading", false).set("error", action.error);

    case ACTIONS.RESET_JOURNEY_SESSION_DETAIL:
      return state.set("sessionDetail", null).set("moreLoading", false).set("error", "");

    default:
      return state;
  }
}
